import * as React from 'react';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { DateView } from 'src/core/ui/date.view';

interface ContractRangeDateListViewProps extends ComponentViewProps<DataSet<ContractRangeDateItem>> {
    mode: ControlMode;
    createDates: () => any;
    contract: ContractItem;
	updateCostPrice: (dates: ContractRangeDateItem, updatePrice: (i: PriceElement) => void) => void;
	product: ProductItem | TourItineraryItem;
}

@observer
export class ContractsDateBandView extends React.Component<ContractRangeDateListViewProps, any> {
    columns: Column[] = [
        {
            key: 'booking',
            title: 'Booking',
            children: [
                {
                    key: 'bookingDateFromText',
                    dataIndex: 'bookingDateFromText',
                    title: 'From',
                    editable: (text: string, record: ContractRangeDateItem, index: number, isSelected: boolean) => {
                        if (isSelected) {
							return (
								<DateView
									mode={this.props.mode}
                                    label={null}
									value={record.bookingDateFrom}
									onChanged={(newVal) => {
										this.props.updateCostPrice(record, (i) => (i as any).bookingDateFrom = newVal.toISOString());
										record.bookingDateFrom = newVal;
									}}
									format="small-date"
									dateUsage="utc"
								/>
							);
                        }
						return text || "";
                    }
                },
                {
                    key: 'bookingDateToText',
                    dataIndex: 'bookingDateToText',
                    title: 'To',
                    editable: (text: string, record: ContractRangeDateItem, index: number, isSelected: boolean, refresh: () => void) => {
                        if (isSelected) {
							return (
								<DateView
									mode={this.props.mode}
                                    label={null}
									value={record.bookingDateTo}
									onChanged={(newVal) => {
										this.props.updateCostPrice(record, (i) => (i as any).bookingDateTo = newVal);
										record.bookingDateTo = newVal;
									}}
									format="small-date"
									dateUsage="utc"
								/>
							);
                        }
						return text || "";
                    }
                }
            ]
        },
        {
            key: 'service',
            title: 'Service',
            children: [
                {
                    key: 'serviceDateFromText',
                    dataIndex: 'serviceDateFromText',
                    title: 'From',
                    editable: (text: string, record: ContractRangeDateItem, index: number, isSelected: boolean) => {
                        if (isSelected) {
							return (
								<DateView
									mode={this.props.mode}
									label={null}
                                    value={record.serviceDateFrom}
                                    onChanged={(newVal) => {
                                        this.props.updateCostPrice(record, (i) => (i as any).serviceDateFrom = newVal);
                                        record.serviceDateFrom = newVal;
									}}
									format="small-date"
									dateUsage="utc"
								/>
							);
                        }
						return text || "";
                    }
                },
                {
                    key: 'serviceDateToText',
                    dataIndex: 'serviceDateToText',
                    title: 'To',
                    editable: (text: string, record: ContractRangeDateItem, index: number, isSelected: boolean) => {
                        if (isSelected) {
							return (
								<DateView
									mode={this.props.mode}
                                    label={null}
									value={record.serviceDateTo}
                                    onChanged={(newVal) => {
                                        this.props.updateCostPrice(record, (i) => (i as any).serviceDateTo = newVal);
                                        record.serviceDateTo = newVal;
									}}
									format="small-date"
									dateUsage="utc"
								/>
							);
                        }
						return text || "";
                    }
                }
            ]
        }
    ];

    constructor(props) {
        super(props);
	}

	@autobind
	async isValidContract(product: ProductItem | TourItineraryItem) {
		const errors = await product.validate(false, 'contracts');
		const result = errors.map(e => e.text);

		return result;
	}

	render() {
		if (this.props.model == null) {
			return null;
		}

		return (
			<DataTableView
				mode={this.props.mode}
				setBusy={this.props.setBusy}
				columns={this.columns}
				isValidItem={() => this.isValidContract(this.props.product) }
				model={this.props.model}
				createNewItem={this.props.createDates}
				hideToolbar={ToolbarVisibility.hideSearch}
				afterDeleteItem={items => {
					for (const item of items) {
						this.props.contract.dateBands.splice(this.props.contract.dateBands.findIndex(e => e.id == item.id), 1);
					}
				}}
			/>
		);
	}
}




// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/contract-dateband.view.tsx